// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * This minimum width is to make sure the side pane does not overlap with the composite when the screen is narrow.
 *
 * @private
 */
export const compositeMinWidthRem = 30;